import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../api';
import AdminFooter from './AdminFooter';
import '../styles/AdminLogin.css';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const errs = {};
    if (!email.trim()) errs.email = 'Email is required.';
    if (!password) errs.password = 'Password is required.';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');
    if (!validate()) return;

    setLoading(true);
    try {
      const { data } = await adminLogin(email.trim(), password, rememberMe);
      const storage = rememberMe ? localStorage : sessionStorage;
      storage.setItem('adminToken', data.token);
      storage.setItem('admin', JSON.stringify(data.admin));
      navigate('/dashboard');
    } catch (err) {
      setServerError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
    <main className="admin-login-main">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <img className="admin-logo" src="/logo.png" alt="Tedo Bizz Logo" />
          <h1 className="admin-login-title">Admin Portal Login</h1>
          <p className="admin-login-subtitle">
            <span className="material-symbols-outlined" style={{ fontSize: 18 }}>lock</span>
            Secure Access
          </p>
        </div>

        {serverError && <div className="admin-banner error">{serverError}</div>}

        <form className="admin-login-form" onSubmit={handleSubmit} noValidate>
          <div className="admin-field-group">
            <label className="admin-field-label" htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              className={`admin-text-input ${errors.email ? 'error' : ''}`}
              placeholder="admin@milieuglobal.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <span className="admin-field-error">{errors.email}</span>}
          </div>

          <div className="admin-field-group">
            <label className="admin-field-label" htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              className={`admin-text-input ${errors.password ? 'error' : ''}`}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {errors.password && <span className="admin-field-error">{errors.password}</span>}
          </div>

          <div className="admin-utilities-row">
            <label className="admin-remember-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              Remember Me
            </label>
            <a className="admin-forgot-link" href="#forgot">Forgot Password?</a>
          </div>

          <button className="admin-submit-btn" type="submit" disabled={loading}>
            <span>{loading ? 'Signing in...' : 'Sign In'}</span>
            {!loading && <span className="material-symbols-outlined" style={{ fontSize: 20 }}>arrow_forward</span>}
          </button>
        </form>
      </div>
    </main>
    <AdminFooter />
    </div>
  );
}
